var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "#FCA905",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1156 1.26059C14.0836 -0.448009 10.9441 -0.191368 9 1.78793C7.05586 -0.191368 3.91641 -0.451525 1.88438 1.26059C-0.759371 3.48598 -0.372652 7.1141 1.51172 9.03715L7.67813 15.3196C8.02969 15.6782 8.50079 15.8786 9 15.8786C9.50274 15.8786 9.97032 15.6817 10.3219 15.3231L16.4883 9.04066C18.3691 7.11762 18.7629 3.48949 16.1156 1.26059ZM15.2859 7.85238L9.11954 14.1348C9.03516 14.2192 8.96485 14.2192 8.88047 14.1348L2.71407 7.85238C1.43086 6.54457 1.17071 4.06957 2.97071 2.55433C4.33829 1.40473 6.44766 1.57699 7.76954 2.92348L9 4.17855L10.2305 2.92348C11.5594 1.56996 13.6688 1.40473 15.0293 2.55082C16.8258 4.06605 16.5586 6.55512 15.2859 7.85238Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a1bbbceb.svg";
export { ForwardRef as ReactComponent };